import type { ComponentProps, CSSProperties } from 'react';
import { cn } from '@rocco/utils/cn';
import { Button } from '@rocco/components/button';
import { ReactComponent as ArrowRight } from '@rocco/icons/svg/arrow/arrow-right.svg';

import { useLeadModal } from '../lead-form/useLeadModal';

export interface B2BCTAButtonProps extends ComponentProps<typeof Button> {
    label: string;
    /** Hide the trailing arrow icon. */
    hideArrow?: boolean;
    /** Inline style applied to the label span — used to set vw-based fontSize. */
    labelStyle?: CSSProperties;
}

/**
 * Primary call-to-action button (e.g. "Apply to Join") used throughout the B2B
 * pages. Clicking it opens the lead modal via {@link useLeadModal}.
 */
export const B2BCTAButton = ({
    label,
    hideArrow,
    className,
    labelStyle,
    ...buttonProps
}: B2BCTAButtonProps) => {
    const { openModal } = useLeadModal();

    return (
        <Button
            type="button"
            className={cn('group', className)}
            onClick={() => openModal({ ctaLabel: label })}
            {...buttonProps}
        >
            {labelStyle ? <span style={labelStyle}>{label}</span> : label}
            {!hideArrow && (
                <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
            )}
        </Button>
    );
};
